





























import Vue from 'vue';
import { Department } from '@/interfaces/ProjectDirector';

export default Vue.extend({
  props: {
    value: Object as () => Department,
    title: String,
    options: Array as () => Array<Department>,
    disabled: Boolean,
    hasError: Boolean,
    submitClicked: Boolean,
  },
  computed: {
    department: {
      get(): Department {
        return this.value;
      },
      set(value: Department): void {
        this.$emit('input', value);
      },
    },
    // TODO: LATER: refactoring many sort functions
    alphabeticalOptions(): Array<Department> {
      const cloneOptions = this.options;
      return cloneOptions.sort((a, b) => a.projectName.localeCompare(b.projectName, 'en', { sensitivity: 'base' }));
    },
  },
  methods: {
    projectNameShortener(projectName: string): string {
      if (projectName.length < 21) return projectName;
      return `${projectName.slice(0, 20)}...`;
    },
  },
});
